var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { DateTimeItem } from './date-time.item';
import { DateFormatType } from '@flexem/fc-gui/model/datetime-display/date-format-type';
import { DatetimeSeparatorType } from '@flexem/fc-gui/model/datetime-display/datetime-separator-type';
import { TimeFormatType } from '@flexem/fc-gui/model/datetime-display/time-format-type';
var DateTimeService = /** @class */ (function () {
    function DateTimeService() {
        this.dateFormatList = [
            new DateTimeItem(DateFormatType.YYMMDD, 'YY*MM*DD'),
            new DateTimeItem(DateFormatType.MMDDYY, 'MM*DD*YY'),
            new DateTimeItem(DateFormatType.DDMMYY, 'DD*MM*YY')
        ];
        this.datetimeSeparatorList = [
            new DateTimeItem(DatetimeSeparatorType.Dot, '.'),
            new DateTimeItem(DatetimeSeparatorType.Line, '-'),
            new DateTimeItem(DatetimeSeparatorType.Slash, '/'),
            new DateTimeItem(DatetimeSeparatorType.CHS, '年月日')
        ];
        this.timeFormatList = [
            new DateTimeItem(TimeFormatType.HHMM, 'HHMM'),
            new DateTimeItem(TimeFormatType.HHMMSS, 'HHMMSS')
        ];
    }
    DateTimeService.prototype.getDateFormat = function () {
        return this.dateFormatList;
    };
    DateTimeService.prototype.getDatetimeSeparator = function () {
        return this.datetimeSeparatorList;
    };
    DateTimeService.prototype.getTimeFormat = function () {
        return this.timeFormatList;
    };
    DateTimeService = __decorate([
        Injectable()
    ], DateTimeService);
    return DateTimeService;
}());
export { DateTimeService };
